var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 4.83366H9.83366V6.50033H8.16699V4.83366Z",
    fill: "#F38D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 8.16699H9.83366V13.167H8.16699L8.16699 8.16699Z",
    fill: "#F38D33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 9.00033C0.666992 4.40033 4.40031 0.666992 9.00033 0.666992C13.6003 0.666992 17.3337 4.40033 17.3337 9.00033C17.3337 13.6003 13.6003 17.3337 9.00033 17.3337C4.40031 17.3337 0.666992 13.6003 0.666992 9.00033ZM2.33366 9.00033C2.33366 12.6753 5.3253 15.667 9.00033 15.667C12.6754 15.667 15.667 12.6753 15.667 9.00033C15.667 5.32532 12.6754 2.33366 9.00033 2.33366C5.3253 2.33366 2.33366 5.32532 2.33366 9.00033Z",
    fill: "#F38D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.bedab75df7e0447d53a2c3229368d1f2.svg";
export { ForwardRef as ReactComponent };